import React, { forwardRef } from 'react';
const PaymentMethods = forwardRef(function PaymentMethods({ testId = 'store-payment-methods', title, 'aria-label': ariaLabel = 'Payment Methods', children, ...otherProps }, ref) {
    return (React.createElement("div", Object.assign({ ref: ref, "data-store-payment-methods": true, "data-testid": testId }, otherProps),
        !!title && React.createElement("div", null, title),
        React.createElement("div", { "data-payment-methods-flags": true, "aria-label": title ? undefined : ariaLabel }, children)));
});
export default PaymentMethods;
//# sourceMappingURL=PaymentMethods.js.map